const SearchActionTypes = {
  SEARCH_START: "SEARCH_START",
  SEARCH_IS_FETCHING: " SEARCH_IS_FETCHING",
  SEARCH_SUCCESS: "SEARCH_SUCCESS",
  SEARCH_FAILURE: "SEARCH_FAILURE",
};

export default SearchActionTypes;
